import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 42095 37151"
    {...props}
  >
    <path
      d="M31712 10922c-208 95 1844-1681 2242-2177l2752-2333c414-515 526-833 994-1301 486-486 1733-1562 1817-2438-939 121-2745 1818-3636 2799l-4973 4062c-501 456-856 151-1407-251 165-693 3130-3557 3839-4348 380-423 604-722 962-1142 678-792 2766-2459 2748-3488h-242c-1716 1307-3248 2644-4976 3984-1722 1335-3216 2715-4683 4212-2299 2347-1490 3313-2355 6534-391 1451-3203 3959-4095 4811-561-339-4783-4323-4996-5469-291-1566 481-2615-177-4710-1293-4129-7323-8272-12105-8463C351 1082 643 2450 305 3113v2176c885 1900 342 2930 2628 6157 1162 1643 2594 3321 4370 4354 3034 1763 5705 61 7279 1434 1323 1157 3380 3134 4323 4341-1319 1592-8187 6586-10130 7947-640 448-1511 1101-1936 1546-3736 3913 862 9518 5923 2265 3613-5178 4284-5805 7782-9975 3230 3041 6281 8627 8956 11368 1144 1173 3462 1933 4844 316 3137-3670-4711-7589-8492-10604l-3498-2955c1010-992 3141-3617 4795-4092 3118-895 4325-200 6557-2342 3070-2945 5317-6385 8084-9660v-366c-765 84-2569 1937-3584 2860l-3281 3158c-371 378-725 598-1133 970-444 406-567 731-974 527-55-28-1038-1568-1106-1616z"
      style={{
        fill: "#2b2a29",
        // stroke: "#000",
        strokeWidth: 610.08,
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
